module.exports = __webpack_public_path__ + "static/media/whatsapp.b528883c.png";